<h2 mat-dialog-title>Import from Tripetto Script</h2>

<mat-dialog-content class="dialog-content">
	<!-- Loading spinner for definitions -->
	<div *ngIf="isLoadingDefinitions" class="loading-container">
		<mat-spinner diameter="50"></mat-spinner>
		<p>Loading Tripetto definitions...</p>
	</div>

	<!-- Main content -->
	<div *ngIf="!isLoadingDefinitions" class="content-container">
		<!-- Search bar -->
		<mat-form-field appearance="outline" class="search-field">
			<mat-label>Search definitions</mat-label>
			<mat-icon matPrefix>search</mat-icon>
			<input matInput [formControl]="searchControl" placeholder="Search by name, description, or ID" />
		</mat-form-field>

		<!-- Definition list -->
		<div class="definition-list-container">
			<h3>Select Tripetto Definition:</h3>
			<mat-selection-list [multiple]="false" class="definition-list">
				<mat-list-option
					*ngFor="let def of filteredDefinitions | async"
					[value]="def"
					[selected]="selectedDefinition?.definitionId === def.definitionId"
					(click)="onDefinitionSelected(def)"
				>
					<div class="definition-item">
						<div class="definition-name">{{ def.name }}</div>
						<div class="definition-id">ID: {{ def.definitionId }}</div>
						<div class="definition-description" *ngIf="def.description">
							{{ def.description }}
						</div>
					</div>
				</mat-list-option>
			</mat-selection-list>

			<div *ngIf="(filteredDefinitions | async)?.length === 0" class="no-results">
				No definitions found matching your search.
			</div>
		</div>

		<!-- Version selector -->
		<div *ngIf="selectedDefinition" class="version-section">
			<mat-form-field appearance="outline" class="version-field">
				<mat-label>Version</mat-label>
				<mat-select
					[(value)]="selectedVersion"
					(selectionChange)="onVersionSelected($event.value)"
					[disabled]="isLoadingVersions"
				>
					<mat-option *ngFor="let v of versions" [value]="v">
						{{ v.version }} (ID: {{ v.versionId }})
						<span *ngIf="v.isPublished" class="published-badge">Published</span>
					</mat-option>
				</mat-select>
				<mat-hint *ngIf="versions.length > 0"
					>{{ versions.length }} version{{ versions.length !== 1 ? 's' : '' }} available</mat-hint
				>
			</mat-form-field>

			<mat-spinner *ngIf="isLoadingVersions" diameter="30" class="inline-spinner"></mat-spinner>
		</div>

		<!-- Conversion progress -->
		<div *ngIf="isConverting" class="conversion-progress">
			<mat-spinner diameter="40"></mat-spinner>
			<p>Converting Tripetto definition to Formly configuration...</p>
		</div>

		<!-- Conversion results -->
		<div *ngIf="conversionResult && !isConverting" class="conversion-results">
			<nx-ahs-conversion-warnings [conversionResult]="conversionResult"></nx-ahs-conversion-warnings>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="onCancel()">Cancel</button>
	<button mat-button color="accent" (click)="downloadReport()" *ngIf="conversionResult" [disabled]="isConverting">
		<mat-icon>download</mat-icon>
		Download Report
	</button>
	<button mat-raised-button color="primary" (click)="onImport()" [disabled]="!canImport">Import & Continue</button>
</mat-dialog-actions>
